import { Injectable } from '@zhfe/vue2-di-plugin'
import client from '@/client/'
import { LOGIN_SERVICE } from '@/config/dataMap'

@Injectable()
export class VideoUserInfoService {
  constructor () {}

  /** 上报首页操作 */
  report (clickType:number, status:number):void{
    client.home.REPORT.reportHomeOperate({ main_click: clickType, user_login: status })
  }

  /** 打开登录窗口 */
  openLoginWindow ():void{
    client.common.API.userLogin({ url: LOGIN_SERVICE.url })
  }

  /** 退出登录 */
  logout () {
    client.common.API.exit()
  }
}
